export const ItemTypes = {
    TYPE: 'type',
    CARD: 'card',
}
